import React from "react";
import Leagues from "views/leagues/leaguesContent";

import { IonPage, IonContent } from "@ionic/react";

import CreateNewLeague from "views/modals/createNewLeague";
import Header from "views/header";

const Lobby = () => {
  return (
    <IonPage>
      <Header />
      <Leagues />
      <CreateNewLeague />
    </IonPage>
  );
};

export default Lobby;
